module.exports = __webpack_public_path__ + "static/media/flip-h-alt.c1a2883f.svg";